import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private datePipe: DatePipe) { }
  formatDateString(date: Date): string {
    const confirmDate = new Date(date);
    if (!isNaN(confirmDate.getTime())) {
      return this.datePipe.transform(confirmDate, 'yyyy-MM-dd') || '';
    } else {
      return '';
    }
  }
}
